import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';

import { DevToolsService, extendDevTools } from '@blaze-shared/platform-data-access';

import { findAndOpenWorkflow } from './target-workflow.actions';

/** Exposes `__BDT.selectWorkflow(id)`, which opens a workflow in the editor by id. */
@Injectable({ providedIn: 'root' })
export class WorkflowDevToolsService {
  private readonly devToolsService = inject(DevToolsService);
  private readonly store = inject(Store);

  private readonly selectWorkflow = (workflowId?: string | null, redirect?: boolean): void => {
    redirect = redirect ?? true;
    if (!workflowId) {
      workflowId = prompt('Please insert workflow ID\n\nWorkflow needs to be within the project');
    }
    if (workflowId) {
      this.store.dispatch(findAndOpenWorkflow({ workflowId, redirect }));
    }
  };

  initialize(): void {
    extendDevTools({
      selectWorkflow: this.selectWorkflow,
    });

    this.devToolsService.messages$
      .pipe(filter(({ action }) => action === 'FEATURE_FUNCTION_REQUEST'))
      .subscribe(({ payload }) => {
        switch (payload.functionName) {
          case 'selectWorkflow': {
            this.selectWorkflow(payload.args[0], payload.args[1]);
            break;
          }
        }
      });
  }
}
